import { IsBoolean, IsNotEmpty } from 'class-validator';

export class EmailVerificationResponse {
    @IsBoolean()
    @IsNotEmpty()
    success: boolean = false;
}
